export default __webpack_public_path__ + "static/media/cabosEthernet.d16714d1.png";